import type { FunctionComponent } from 'react';
import { IProductsList } from '../../../utils/ContextProviders/ReactivateContext';
import * as styles from './HowItWorks.module.scss';

export const HOW_IT_WORKS_SECTION_ID = 'how-it-works-section';

type HowItWorksProps = {
  productsList: IProductsList;
  headline: string;
};

const HowItWorks: FunctionComponent<HowItWorksProps> = ({ productsList, headline }) => (
  <section className={styles.howItWorksSection}>
    <h2 className={styles.sectionTitle}>{headline || 'How It Works'}</h2>
    <ul className={styles.listWrapper} data-testid={HOW_IT_WORKS_SECTION_ID}>
      {productsList?.length > 0 &&
        productsList.map((product) => (
          <li key={product.title} className={styles.listItem}>
            <div className={styles.captionContainer}>
              <h3 className={styles.itemTitle}>{product.title}</h3>
              <p className={styles.itemContent}>{product.caption}</p>
            </div>
          </li>
        ))}
    </ul>
  </section>
);

export default HowItWorks;
